// gameConstants.js
'use strict';

const Game = {
  SIC_BO: 'sic-bo',
  DRAGON_TIGER_FIGHT: 'dragon-tiger-fight',
  GIFT_SLOT: 'gift-slot',
  SOARING_HIGH: 'soaring-high',
  GOLDEN_GATE: 'golden-gate',
  UGPP_SICBO: 'ugpp-sicbo',
  UGPP_CUPID_GIFT: 'ugpp-cupid-gift',
  UGPP_DRAGON_TIGER: 'ugpp-dragon-tiger',
};

// The UI that renders a game and owns its lifecycle — not a redux container.
const GameHost = {
  LIVESTREAM_PANEL: 'livestream-panel',
  MODAL: 'modal',
};

const UGPP_GAME_ID_PREFIX = 'ugpp-';

/**
 * Whether a game id belongs to a UGPP game. UGPP game ids are prefixed with
 * `ugpp-` (e.g. `ugpp-sicbo`), which is how they are routed to GameUgpp.
 * @param {object} params
 * @param {string} params.gameId - The game id to test.
 * @returns {boolean} True if the id is a UGPP game id.
 * @example
 * getIsUgppGame({ gameId: 'ugpp-sicbo' }); // => true
 * getIsUgppGame({ gameId: 'sic-bo' }); // => false
 */
const getIsUgppGame = ({ gameId }) =>
  typeof gameId === 'string' && gameId.startsWith(UGPP_GAME_ID_PREFIX);

/**
 * The UGPP game code of a game id — the part after the `ugpp-` prefix.
 * @param {object} params
 * @param {string} params.gameId - The game id.
 * @returns {string|undefined} The game code, or undefined when the id is not a UGPP game.
 * @example
 * getUgppGameCode({ gameId: 'ugpp-sicbo' }); // => 'sicbo'
 * getUgppGameCode({ gameId: 'sic-bo' }); // => undefined
 */
const getUgppGameCode = ({ gameId }) =>
  getIsUgppGame({ gameId })
    ? gameId.replace(UGPP_GAME_ID_PREFIX, '')
    : undefined;

/**
 * The acquisition-token third party name of a UGPP game.
 * @param {object} params
 * @param {string} params.gameId - The game id.
 * @returns {string|undefined} The third party name, or undefined when the id is not a UGPP game.
 * @example
 * getUgppThirdPartyName({ gameId: 'ugpp-sicbo' }); // => 'ugpp/sicbo'
 * getUgppThirdPartyName({ gameId: 'sic-bo' }); // => undefined
 */
const getUgppThirdPartyName = ({ gameId }) => {
  const gameCode = getUgppGameCode({ gameId });
  return gameCode ? `ugpp/${gameCode}` : undefined;
};

export {
  Game,
  GameHost,
  getIsUgppGame,
  getUgppGameCode,
  getUgppThirdPartyName,
};
